import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { CreateSignature } from "../createSignature/CreateSignature";
import DownloadIcon from '@mui/icons-material/Download';
import { getDocumentToSign, SaveSingnature } from '../../../redux/actions/signDocument';
import '../../../styles/components/_createsignature.scss';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import PersonIcon from '@mui/icons-material/Person';
import { useNavigate } from 'react-router-dom';
const idFlowSaveData = process.env.REACT_APP_ID_FLOW_SAVE_FINAL_DATA_AND_IMAGE_SIGNATURE;

export const LayoutSignDocument = () => {
    const { token } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [images, setImages] = useState([]);
    const [signatures, setSignatures] = useState([]);
    const handleClose = () => setOpen(false);
    const {
        dataDocumentToSign
    } = useSelector(state => state.signDocument)

    useEffect(() => {
        if (dataDocumentToSign && dataDocumentToSign?.pages)
            setImages(dataDocumentToSign.pages);
        else
            setImages([]);
    }, [dataDocumentToSign]);

    useEffect(() => {
        dispatch(getDocumentToSign(token));
    }, [dispatch, token]);

    const setSignature = (obj) => {
        setSignatures([...signatures, obj]);
        handleClose();
    }

    const [objectToSign, setObjectToSign] = useState(null);
    const handleOpen = (id_signature, order) => {
        setObjectToSign({ id_signature, order });
        setOpen(true);
    }

    const GetIcon = (type) => {
        switch (type) {
            case "Nombre":
                return <PersonIcon color="#040404" sx={{ fontSize: 20 }} />;
            case "Sello":
                return <TextSnippetIcon color="#040404" sx={{ fontSize: 20 }} />;
            default:
                return <DownloadIcon color="#040404" sx={{ fontSize: 20 }} />;
        }
    }

    const handleFinalize = () => {
        signatures.forEach((item) => {
            let obj = {
                "id_flow": idFlowSaveData,
                "token": token,
                "id_signature": item.id_signature,
                "order": item.order,
                "signature": item.img.split(",")[1]
            };
            dispatch(SaveSingnature(obj));
        });
        setTimeout(() => {
            navigate('/login');
        }, 1500);
    }

    return (
        <>
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Paper
                    sx={{
                        width: '80%', mb: 2,
                        boxShadow: (theme) => `0px 0px 8px 0px rgba(0,0,0,${theme.palette.dark === 'dark' ? 0.75 : 0.25})`,
                        WebkitBoxShadow: (theme) => `0px 0px 8px 0px rgba(0,0,0,${theme.palette.dark === 'dark' ? 0.75 : 0.25})`,
                        bgcolor: (theme) => theme.palette.paper.background,
                    }}
                    elevation={3}
                >
                    <Box sx={{ minHeight: '80vh', backgroundColor: '#f5f5f5', padding: 3 }}>
                        <Typography variant='h5'>Documento a firmar: {dataDocumentToSign?.name}</Typography>
                        <Box sx={{ marginTop: "20px" }}>
                            <Box sx={{ display: "flex", justifyContent: "center", margin: "15px 0" }}>
                                <Box
                                    className='pdfAreaStyle'
                                    sx={{
                                        width: "800px", // Ancho fijo
                                        height: "600px", // Altura fija
                                        overflow: "auto", // Activar scroll horizontal y vertical
                                        border: "1px solid gray", // Opcional: para ver los bordes
                                        position: "relative", // Mantener elementos posicionados correctamente
                                    }}
                                >
                                    {
                                        (images && images.length > 0) ?
                                            images.map((item, index) => (
                                                <>
                                                    <Box
                                                        key={index}
                                                        sx={{
                                                            position: "relative",
                                                            width: `${item.image_size_width}px`,
                                                            height: `${item.image_size_height}px`,
                                                            margin: "0 auto", // Centrar contenido
                                                            textAlign: "center",
                                                            border: "2px solid black",
                                                        }}
                                                    >
                                                        <img
                                                            src={item.url_page}
                                                            alt={`page-${index}`}
                                                            style={{
                                                                width: "100%",
                                                                height: "100%",
                                                                pointerEvents: "none"
                                                            }}
                                                        />

                                                        {
                                                            item.signature.map((sign, index) => (
                                                                signatures.find((p) => p.id_signature === sign.id_signature) ? (
                                                                    <div>
                                                                        <img
                                                                            key={index}
                                                                            src={signatures.find((p) => p.id_signature === sign.id_signature)?.img}
                                                                            alt="Firma digital"
                                                                            style={{
                                                                                position: 'absolute',
                                                                                top: `${sign.pixel_y ?? 0}px`,
                                                                                left: `${sign.pixel_x ?? 0}px`,
                                                                                width: `${sign.width}px`,
                                                                                height: `${sign.height}px`,
                                                                            }}
                                                                        />
                                                                    </div>
                                                                ) : (
                                                                    <Card
                                                                        key={sign.id_signature}
                                                                        className='cardOptionStyle'
                                                                        sx={{
                                                                            position: "absolute",
                                                                            top: `${sign.pixel_y}px`,
                                                                            left: `${sign.pixel_x}px`,
                                                                            width: `${sign.width}px`,
                                                                            height: `${sign.height}px`,
                                                                        }}
                                                                        onClick={() => handleOpen(sign.id_signature, item.order)}
                                                                    >
                                                                        <CardContent
                                                                            className="CardContent"
                                                                        >
                                                                            {GetIcon(sign.type)}
                                                                            <Typography className="CardTypography">{sign.type}</Typography>
                                                                        </CardContent>
                                                                    </Card>
                                                                )
                                                            ))
                                                        }
                                                    </Box>
                                                    <Grid>
                                                        <Typography variant="inherit">
                                                            page {index + 1} de {images.length}
                                                        </Typography>
                                                    </Grid>
                                                </>
                                            ))
                                            :
                                            <Box
                                                style={{
                                                    position: 'relative',
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    flexDirection: 'column',
                                                    marginTop: '10px'
                                                }}
                                            >
                                                <CircularProgress
                                                    sx={{ marginTop: 50 }}
                                                    color='primary'
                                                />
                                            </Box>
                                    }
                                </Box>
                            </Box>
                            <Box sx={{ display: "flex", justifyContent: "center" }}>
                                <Button
                                    variant='contained'
                                    color='success'
                                    onClick={handleFinalize}
                                    sx={{ mx: 3 }}
                                >
                                    Finalizar
                                </Button>
                            </Box>
                        </Box>
                    </Box>
                </Paper>
            </Box>
            <CreateSignature
                open={open}
                objectToSign={objectToSign}
                setSignature={setSignature}
                onClose={handleClose}
            />
        </>
    );
};